import React, { useEffect, useState } from 'react';
import FilterButton from './FilterButton';
import MultiSelectFilterButton from './MultiSelectFilterButton';
import './filters.css';

const Filters = (props) => {
  const [ state, setState ] = useState({
    selected: props.selected,
    subFiltersSelected: [],
  });

  useEffect(() => {
    const { allFilters, mode } = props;
    if (mode==='subFilters') {
      const selectedSubFilters = allFilters.map(() => false);
      setState({
        ...state,
        subFiltersSelected: selectedSubFilters
      });
    }
  }, []);

  const toggleMultiSelected = (index) => {
    const selectedFilter=state.subFiltersSelected;
    selectedFilter[index] = !selectedFilter[index];
    setState({ ...state, subFiltersSelected: selectedFilter });
  };

  const toggleSelected = (filter) => () => {
    setState({ ...state, selected: filter });
    props.onSelected(filter);
  };

    return (
      <div className={`${props.mode} flexSliderWrap`}>
        <ul className="makeFlex filtersList">
          {props.allFilters.map((filter, index) => {
            return props.mode!=='subFilters' ?
              <FilterButton
                filter={filter}
                key={filter.id}
                toggleSelected={toggleSelected(filter)}
                selected={state.selected}
              /> :
              <MultiSelectFilterButton
                index={index}
                filter={filter}
                key={filter.id}
                toggleMultiSelected={toggleMultiSelected}
                selected={state.subFiltersSelected}
              />;
          })}
        </ul>
      </div>
    );
  }

  export default Filters;
